export const INSTRUCTOR_FEATURE_KEY = 'instructor';
